export default "__VITE_ASSET__DSoLvexz__"